<template>
    <div
        class="group-btn-zoom"
        :class="openSurveys ? 'open-surveys' : 'close-surveys'"
    >
        <v-row>
            <div class="col-lg-12 col-md-12 col-sm-2 buttons-zoom">
                <v-btn
                    icon
                    color="gray"
                    title="Mas"
                    @click="plus()"
                    class="btn-zoom"
                >
                    <v-icon>mdi-magnify-plus-outline</v-icon>
                </v-btn>
            </div>
            <div class="col-lg-12  col-md-12 col-sm-2 buttons-zoom">
                <v-btn
                    class="btn-zoom"
                    icon
                    color="gray"
                    title="Menos"
                    :disabled="zoom < 20"
                    @click="minus()"
                >
                    <v-icon>mdi-magnify-minus-outline</v-icon>
                </v-btn>
            </div>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "RomaPdfBtnZoom",
    computed: {
        ...mapGetters({
            getZoom: "getZoom",
            openSurveys: "getOpenSurveys"
        }),
        zoom: {
            get() {
                return this.getZoom;
            },
            set(zoom) {
                return zoom;
            }
        }
    },
    methods: {
        ...mapActions({
            setZoom: "setZoom"
        }),
        plus() {
            this.setZoom({ zoom: (this.zoom += 10) });
        },
        minus() {
            this.setZoom({ zoom: (this.zoom -= 10) });
        }
    }
};
</script>

<style lang="scss" scoped>
.group-btn-zoom {
    position: absolute;
    z-index: 10;
    .btn-zoom {
        background: rgba(0, 0, 0, 0.1);
    }
    .buttons-zoom {
        margin-right: 5px;
    }
}

@media (max-width: 800px) {
    .group-btn-zoom {
        position: absolute;
        bottom: 20px;
    }
    .open-surveys {
        right: 118px;
    }
    .close-surveys {
        right: 30px;
    }
    .buttons-zoom {
        margin: 0;
        width: 50%;
    }
}
</style>
